import React, { Component } from 'react';
import Modal from 'react-modal';
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { hideModal, MODAL_STUDENT_FORM_VIEW } from '../../../../modules/modals';
import InputField from '../../../helpers/Fields/InputField';
import moment from 'moment';

class FormView extends Component {
  static contextTypes = {formatMessage: PropTypes.any};

  handleClose = () => {
    const { hideModal } = this.props;
    hideModal({ modalType : MODAL_STUDENT_FORM_VIEW});

  }

  getTitle = () => {
    const {formatMessage} = this.context
    let text = "frmTitleStudentPrifile";
    return <div className="create-dialog-modal-content__title">{formatMessage(text)}</div>;
  }

  render() {
    const {formatMessage} = this.context
    const {zIndex, student} = this.props;
    let img = './images/avatar/noavatar.png'
    if(student.avatar != 'images/avatar/profile.png'){
      img = './' + student.avatar;
    }

    return (
      <Modal
          isOpen = {true}
          style = {{
              overlay : {zIndex},
          }}
          onRequestClose={this.handleClose}
          overlayClassName = "custom-modal"
          className = "custom-modal-content create-dialog-modal-content"
      >
          <div className="create-dialog-modal-content__header">
              {
                this.getTitle()
              }
              <div
                  onClick={this.handleClose}
                  className="create-dialog-modal-content__close"
              ></div>
          </div>
          <div className="create-dialog-modal-content__body">
            <div className="Modal-student-profile">
              <div className="col1">
                <div className="avatar" style={{backgroundImage: `url(${img})`, backgroundPosition: 'center', backgroundSize: 'cover'}}></div>
              </div>
              <div className="col2">
                <InputField 
                  input={{
                    value: student.firstname
                  }}
                  disabled
                  meta={{}}
                  label={formatMessage('txtCaptionStudentFirstName')}
                />
                <InputField 
                  input={{
                    value: student.lastname
                  }}
                  disabled
                  meta={{}}
                  label={formatMessage('txtCaptionStudentLastName')}
                />
                <InputField 
                  input={{
                    value: student.email
                  }}
                  disabled
                  meta={{}}
                  label={formatMessage('txtCaptionStudentEmail')}
                />
                <div className="field">
                  <label>{formatMessage('txtInvitationStatus')}:</label>  {student.password_hash ? 'Accepted' : 'Pending'}    
                </div>
                <div className="field">
                  <label>{formatMessage('txtTotalTimeInQBM')}: {moment().diff(moment(student.created_at *1000), 'days')}days</label>  
                </div>
              </div>
              
            </div>
          </div>
      </Modal>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  
})

const mapDispatchToProps = {
  hideModal
}

export default connect(mapStateToProps, mapDispatchToProps)(FormView)



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/Students/components/FormView/index.jsx